window.setCandidate = () => {
    const whereMetChecked = document.querySelector("#candidate_where_we_met_input input:checked");
    const locPrefChecked = document.querySelector("#candidate_location_preference_input input:checked");
    const positionId = document.getElementById("candidate_position_id");

    toggleHow(whereMetChecked ? whereMetChecked.value : "");
    toggleExp();
    toggleLocPrefs(locPrefChecked ? locPrefChecked.value : "");
    toggleExpHint(positionId ? positionId.value : "");
    repopulateLocationDetails(locPrefChecked ? locPrefChecked.value : "");
};

window.showOther = (val) => {
    const directConnection = document.getElementById("candidate_where_we_met_dc").checked;
    const pronoun = document.getElementById("candidate_pronoun");
    togglePronoun(pronoun.value);

    let howWeMet;
    if (directConnection) {
        howWeMet = document.getElementById("candidate_how_we_met_dc").value;
    } else {
        howWeMet = document.getElementById("candidate_how_we_met_ol").value;
    }

    document.getElementById("candidate_heard_through_sm").style.display = "none";
    document.getElementById("candidate_heard_through_jb").style.display = "none";
    document.getElementById("candidate_heard_through_other_input").style.display = "none";
    document.getElementById("candidate_heard_through_university_input").style.display = "none";
    document.getElementById("candidate_heard_through_other").placeholder = "";

    if (howWeMet === "University Visit") {
        document.getElementById("candidate_heard_through_university_input").style.display = "";
    } else if (howWeMet === "Professional Organization or Meeting") {
        document.getElementById("candidate_heard_through_other_input").style.display = "";
        document.getElementById("candidate_heard_through_other").placeholder = "e.g. TRB, ITE, ASCE, WTS, etc.";
    } else if (howWeMet === "Social Media") {
        document.getElementById("candidate_heard_through_sm").style.display = "";
    } else if (howWeMet === "Job Board") {
        document.getElementById("candidate_heard_through_jb").style.display = "";
        const jobBoard = document.getElementById("candidate_how_we_met_jb");
        if (jobBoard && jobBoard.value === "Other") {
            document.getElementById("candidate_heard_through_other").placeholder = "Which Job Board?";
            document.getElementById("candidate_heard_through_other_input").style.display = "";
        }
    } else if (howWeMet === "Other" || val === "Other") {
        document.getElementById("candidate_heard_through_other").placeholder = "";
        document.getElementById("candidate_heard_through_other_input").style.display = "";
    } else if (directConnection && val !== "") {
        document.getElementById("candidate_heard_through_other_input").style.display = "";
        document.getElementById("candidate_heard_through_other").placeholder = "Which " + val + "?";
    }
};

window.toggleExp = () => {
    const internInput = document.querySelectorAll('#candidate_intern_input input[type=radio]:checked, #candidate_intern_input input[type=hidden]');
    let internVal = null;
    for (const input of internInput) {
        if (input.value !== "") {
            internVal = input.value;
            break;
        }
    }
    const requireCoverLetter = document.getElementById("candidate_require_cover_letter_input");
    const coverLetterInput = document.getElementById("candidate_cover_letter_input");
    const coverLetterLabel = coverLetterInput ? coverLetterInput.querySelector("label") : null;

    const showElements = (selectors) => {
        selectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(el => el.style.display = "");
        });
    };
    const hideElements = (selectors) => {
        selectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(el => el.style.display = "none");
        });
    };

    if (internVal === 'true') {
        showElements([
            '#candidate_intern_experience_input',
            '#candidate_location_preference_input',
            '#candidate_intern_list_subscribe_input',
            '.intern-question'
        ]);
        hideElements([
            '#candidate_full_time_experience_input',
            '.full-question'
        ]);
    } else if (internVal === 'false') {
        showElements([
            '#candidate_full_time_experience_input',
            '.full-question'
        ]);
        hideElements([
            '#candidate_intern_experience_input',
            '#candidate_intern_list_subscribe_input',
            '#candidate_location_preference_input',
            '.intern-question'
        ]);
    }

    if ((requireCoverLetter && requireCoverLetter.value === 'true') || internVal === 'true') {
        if (coverLetterInput) {
            coverLetterInput.classList.add('required');
            coverLetterInput.classList.remove('optional');
            if (coverLetterLabel) {
                coverLetterLabel.textContent = "Cover Letter";
                const abbr = document.createElement('abbr');
                abbr.title = "required";
                abbr.textContent = "*";
                coverLetterLabel.appendChild(abbr);
            }
        }
    } else if ((requireCoverLetter && requireCoverLetter.value === 'false') && internVal === 'false') {
        if (coverLetterInput) {
            coverLetterInput.classList.add('optional');
            coverLetterInput.classList.remove('required');
            if (coverLetterLabel) {
                coverLetterLabel.textContent = "Cover Letter (Optional)";
                const abbr = coverLetterLabel.querySelector("abbr");
                if (abbr) abbr.remove();
            }
        }
    }
};

window.toggleHow = (val) => {
    const dc = document.getElementById("candidate_heard_through_dc");
    const online = document.getElementById("candidate_heard_through_online");
    if (val === "dc") {
        if (dc) dc.style.display = "";
        if (online) online.style.display = "none";
        const howWeMetDC = document.getElementById("candidate_how_we_met_dc");
        showOther(howWeMetDC ? howWeMetDC.value : "");
    } else if (val === "ol") {
        if (online) online.style.display = "";
        if (dc) dc.style.display = "none";
        const howWeMet = document.getElementById("candidate_how_we_met");
        showOther(howWeMet ? howWeMet.value : "");
    }
};

window.togglePronoun = (val) => {
    const pronounOtherInput = document.getElementById("candidate_pronoun_other_input");
    if (!pronounOtherInput) return;
    if (val.startsWith("Other")) {
        pronounOtherInput.style.display = "";
    } else {
        pronounOtherInput.style.display = "none";
    }
};

window.toggleExpHint = (val) => {
    const expInput = document.getElementById("candidate_full_time_experience_input");
    if (!expInput) return;
    const hint = expInput.querySelector('p.inline-hints');
    if (!hint) return;
    if (val === '1') {
        hint.textContent = 'Choose a range that reflects your full-time experience in the transportation field, excluding school work & internships';
    } else {
        hint.textContent = 'Choose a range that reflects your full-time experience directly relevant to the position you\'re applying for, excluding school work & internships';
    }
};

window.repopulateLocationDetails = (locPref) => {
    const locationDetails = document.getElementById("candidate_location_details");
    if (!locationDetails || !locationDetails.value) return;

    if (locPref === "Specific") {
        const specificLocations = document.getElementById("candidate_specific_locations");
        const specificLocationDetailsTextarea = document.querySelector("#candidate_specific_location_details_input textarea");
        
        if (!specificLocations || !specificLocationDetailsTextarea) return;

        // Split on newline to separate locations from details
        const valueParts = locationDetails.value.split("\n");
        const locationsPart = valueParts[0].trim();
        const detailsPart = valueParts.slice(1).join("\n").trim();

        if (locationsPart) {
            // Split on ", " to get individual parts
            // Since each location is "City, State", splitting gives us alternating City/State pairs
            // We need to group every two consecutive items into "City, State"
            const locationParts = locationsPart.split(", ");
            const locations = [];
            
            // Group pairs: every two consecutive parts form a "City, State" location
            for (let i = 0; i < locationParts.length; i += 2) {
                if (i + 1 < locationParts.length) {
                    // We have both City and State
                    locations.push(locationParts[i] + ", " + locationParts[i + 1]);
                } else if (locationParts[i]) {
                    // Odd number of parts - might be incomplete data, but include it anyway
                    locations.push(locationParts[i]);
                }
            }

            // Select matching options in the select element
            Array.from(specificLocations.options).forEach(option => {
                if (locations.includes(option.text)) {
                    option.selected = true;
                }
            });
        }

        if (detailsPart && specificLocationDetailsTextarea) {
            specificLocationDetailsTextarea.value = detailsPart;
        }
    } else if (locPref === "Unsure") {
        const unsureLocationsTextarea = document.querySelector("#candidate_unsure_locations_input textarea");
        if (unsureLocationsTextarea) {
            // For Unsure, the value is stored directly (may contain commas and newlines)
            unsureLocationsTextarea.value = locationDetails.value;
        }
    }
};

window.combineOptions = () => {
    const directConnection = document.getElementById("candidate_where_we_met_dc").checked;
    let howWeMet;
    if (directConnection) {
        howWeMet = document.getElementById("candidate_how_we_met_dc");
    } else {
        howWeMet = document.getElementById("candidate_how_we_met_ol");
    }
    const other = document.getElementById("candidate_heard_through_other");
    if (howWeMet.value === "Job Board") {
        const jobBoard = document.getElementById("candidate_how_we_met_jb");
        if (jobBoard.value === "Other") {
            howWeMet.options[howWeMet.selectedIndex].value = "Job Board: Other: " + other.value;
        } else {
            howWeMet.options[howWeMet.selectedIndex].value = "Job Board: " + jobBoard.value;
        }
    } else if (howWeMet.value === "Social Media") {
        const socialMed = document.getElementById("candidate_how_we_met_sm");
        howWeMet.options[howWeMet.selectedIndex].value = "Social Media: " + socialMed.value;
    } else if (howWeMet.value === "Other") {
        howWeMet.options[howWeMet.selectedIndex].value = "Other: " + other.value;
    } else if (directConnection) {
        if (howWeMet.value === "University Visit") {
            const heardUni = document.getElementById("candidate_heard_through_university");
            howWeMet.options[howWeMet.selectedIndex].value = "University Visit: " + heardUni.value;
        } else {
            const newVal = howWeMet.value + ": " + other.value;
            howWeMet.options[howWeMet.selectedIndex].value = newVal;
        }
    }
    document.getElementById("candidate_how_we_met").value = howWeMet.value;

    const pronoun = document.getElementById("candidate_pronoun");
    if (pronoun.value.startsWith("Other")) {
        pronoun.options[pronoun.selectedIndex].value = "Other: " + document.getElementById("candidate_pronoun_other").value;
    }

    const locPrefInput = document.querySelector("#candidate_location_preference_input input:checked");
    const loc_pref = locPrefInput ? locPrefInput.value : null;
    const locationDetails = document.getElementById("candidate_location_details");
    if (loc_pref === "Specific") {
        const specificLocations = document.getElementById("candidate_specific_locations");
        const selectedOptions = Array.from(specificLocations.selectedOptions).map(item => item.text);
        const details = document.querySelector("#candidate_specific_location_details_input textarea").value;
        locationDetails.value = details
            ? selectedOptions.join(", ") + "\n" + details
            : selectedOptions.join(", ");
    } else if (loc_pref === "Unsure") {
        locationDetails.value = document.querySelector("#candidate_unsure_locations_input textarea").value;
    } else {
        locationDetails.value = null;
    }
};

window.toggleLocPrefs = (val) => {
    const specificLocationsInput = document.getElementById("candidate_specific_locations_input");
    const specificLocationDetailsInput = document.getElementById("candidate_specific_location_details_input");
    const unsureLocationsInput = document.getElementById("candidate_unsure_locations_input");

    if (val === "Specific") {
        if (specificLocationsInput) specificLocationsInput.style.display = "";
        if (specificLocationDetailsInput) specificLocationDetailsInput.style.display = "";
        if (unsureLocationsInput) unsureLocationsInput.style.display = "none";
    } else if (val === "Unsure") {
        if (unsureLocationsInput) unsureLocationsInput.style.display = "";
        if (specificLocationsInput) specificLocationsInput.style.display = "none";
        if (specificLocationDetailsInput) specificLocationDetailsInput.style.display = "none";
    } else {
        if (specificLocationsInput) specificLocationsInput.style.display = "none";
        if (unsureLocationsInput) unsureLocationsInput.style.display = "none";
        if (specificLocationDetailsInput) specificLocationDetailsInput.style.display = "none";
    }
};
